import React from 'react'
import PropTypes from 'prop-types'
import useCase from '../hooks/use-case'

function WhenCaseIs (props) {
  const caseValue = useCase()

  if (caseValue !== props.value) {
    return null
  }

  return props.children
}

WhenCaseIs.defaultProps = {
  value: null
}

WhenCaseIs.propTypes = {
  value: PropTypes.any.isRequired
}

export default WhenCaseIs
